import React, { useState, useEffect, useCallback } from 'react';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { immunizationSchedule } from '../helpers/immunizationSchedule';
import { Button, Card, Spinner } from '../components/UI';
import { calculateAgeMonths } from '../helpers/utils';

export default function ImmunizationScreen({ user, child }) {
    const [immunizationData, setImmunizationData] = useState({});
    const [loading, setLoading] = useState(true);
    const ageInMonths = calculateAgeMonths(child.dob.toDate());

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const docRef = doc(db, `users/${child.ownerUid || user.uid}/children/${child.id}/privateData/immunization`);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setImmunizationData(docSnap.data());
            }
        } catch (error) {
            console.error("Error fetching immunization data:", error);
        } finally {
            setLoading(false);
        }
    }, [user.uid, child.id, child.ownerUid]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleStatusChange = async (imunisasiName, isDone) => {
        const newData = {
            ...immunizationData,
            [imunisasiName]: {
                done: isDone,
                date: isDone ? new Date().toISOString().split('T')[0] : null
            }
        };
        setImmunizationData(newData); // Optimistic update
        try {
            const docRef = doc(db, `users/${child.ownerUid || user.uid}/children/${child.id}/privateData/immunization`);
            await setDoc(docRef, newData, { merge: true });
        } catch (error) {
            console.error("Error updating immunization data:", error);
            // Revert on error if needed
            fetchData();
        }
    };

    if (loading) {
        return <Spinner />;
    }

    return (
        <div className="space-y-4">
            {immunizationSchedule.map((item, index) => {
                const status = immunizationData[item.name];
                const isDue = ageInMonths >= item.age && !status?.done;
                const isDone = status?.done;
                
                let cardBg = "bg-white";
                if (isDone) cardBg = "bg-green-50";
                if (isDue) cardBg = "bg-yellow-50";

                return (
                    <Card key={index} className={cardBg}>
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                            <div>
                                <p className="font-bold text-gray-800">{item.name}</p>
                                <p className="text-xs text-gray-500">Jadwal: Usia {item.age} bulan</p>
                                <p className="text-sm text-gray-600 mt-1">{item.description}</p>
                            </div>
                            <div className="mt-4 sm:mt-0 sm:ml-4 flex-shrink-0">
                                {isDone ? (
                                    <div className="text-center">
                                        <p className="text-sm font-semibold text-green-700">✓ Sudah Diberikan</p>
                                        <p className="text-xs text-gray-500">({status.date})</p>
                                    </div>
                                ) : (
                                    <Button 
                                        onClick={() => handleStatusChange(item.name, true)} 
                                        small 
                                        className={`w-full ${isDue ? 'bg-yellow-500 hover:bg-yellow-600' : 'bg-gray-500 hover:bg-gray-600'}`}
                                    >
                                        Tandai Sudah
                                    </Button>
                                )}
                            </div>
                        </div>
                    </Card>
                );
            })}
        </div>
    );
}
